export default __webpack_public_path__ + "static/media/packing-process.5f78907c.JPG";